var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUspLeaves = function SvgUspLeaves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 22,
    r: 22,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0023 21.2267C51.1017 21.2379 48.2317 21.8203 45.5561 22.9406C42.8805 24.061 40.4519 25.6974 38.4087 27.7564C36.3656 29.8154 34.748 32.2566 33.6483 34.9408C32.5487 37.6249 31.9884 40.4994 31.9997 43.4C34.9003 43.3888 37.7704 42.8064 40.4459 41.6861C43.1215 40.5657 45.5502 38.9293 47.5933 36.8703C49.6364 34.8113 51.254 32.3701 52.3537 29.6859C53.4534 27.0018 54.0136 24.1273 54.0023 21.2267V21.2267Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7894 28.4107C39.3 24.0605 39.5611 19.374 38.5429 14.8829C37.5248 10.3919 35.2683 6.27613 32.0294 3.00269C28.778 6.28878 26.5168 10.4234 25.5043 14.934C24.4919 19.4445 24.769 24.1489 26.304 28.5094",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 21.2267C15.8598 21.2507 21.4676 23.6001 25.5928 27.7583C29.7179 31.9164 32.0226 37.5428 31.9999 43.4C26.1428 43.376 20.5349 41.0266 16.4098 36.8684C12.2846 32.7103 9.97993 27.0839 10.0026 21.2267V21.2267Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0024 53.0027V43.4",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00244 63C10.6579 56.5106 21.1844 53.0027 32.0024 53.0027C42.8205 53.0027 53.3469 56.5106 62.0024 63",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUspLeaves;